class autoSelectCtrl {
    constructor($scope, httpRequest, logger, $state) {
        $scope.companyProperty = JSON.parse(localStorage.user_info).sale.companyProperty
        $scope.param = {}
        httpRequest.get_dictByTypeArr(['is_received', 'priority_name']).then((res) => {
            $scope.dictData = res.data.value
            if ($scope.companyProperty == 1) {
                $scope.dictData.is_received.splice(1)
                $scope.param.checkSource = '1'
            } else {
                $scope.dictData.is_received.unshift({
                    enumName: '全部',
                    enumCode: '',
                })
                $scope.param.checkSource = $scope.param.checkSource ? $scope.param.checkSource : ''
            }
        })
        httpRequest.get_getAutoCheckConfigList().then((res) => {
            $scope.param.listData = res.data.value.autoCheckConfigList
            $scope.param.priorityList = res.data.value.autoCheckPriorityList
            if (res.data.value.checkSource) $scope.param.checkSource = res.data.value.checkSource
        })
        $scope.priorityFieldChange = function priorityFieldChange(val, index) {
            $scope.dictData.priority_name.forEach((obj) => {
                if (obj.enumCode == val) $scope.param.priorityList[index].remark = obj.remark
            })
        }
        $scope.edit = function edit(obj, k) {
            obj[k] = false
        }
        $scope.ok = function ok() {
            $scope.param.listData.forEach((item) => {
                if (item.maxAuthTaxamount === null) item.maxAuthTaxamount = ''
                if (item.maxDrawbackTaxamount === null) item.maxDrawbackTaxamount = ''
            })
            httpRequest.post_updateAutoCheckConfig({
                autoCheckConfigList: $scope.param.listData,
                autoCheckPriorityList: $scope.param.priorityList,
                checkSource: $scope.param.checkSource,
            }).then(() => {
                logger.logSuccess('保存成功')
                $state.go('system.settingcenter.inputRule.list')
            })
        }
        $scope.cancel = function cancel() {
            $state.go('system.settingcenter.inputRule.list')
        }
    }
}

autoSelectCtrl.$inject = ['$scope', 'httpRequest', 'logger', '$state']
export default autoSelectCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/inputRule/autoSelectCtrl.js